import React, { useEffect, useState, useMemo } from 'react';
import { getdata, TIMEDATA, DAILYAVAILABLETIME, CLOSEDDATA, updatedata,formatdate, getdate } from "../../util/global";
import DashboardTable from './AppointmentTable';
import AppointmentForm from './AppointmentForm';


const Appointment = () => {
  const [appointmentdata, setappointments] = useState([]);
  const [patientdata, setpatientdata] = useState([]);

  const [showmodal, setshowmodal] = useState(false);
  const [formdata, setformdata] = useState({date:"", time:"", comment:"", name:"", phonenumber:"", _id: null});

  
  const fetchdata = async () => {
    try {
      let data = await getdata({filter:{datatype:"appointmentdata"}});
      setappointments(data.reverse());
      data = await getdata({filter:{datatype:"patientdata", _userid:window.APPUSER.user.userid}});
      setpatientdata(data.reverse());
    } catch (err) { console.error(err); }
  };


  const openedit = (item) => {
    const [d, t] = item.datetime.split("T");
    setformdata({date: d, datestr:item.datestr, time: t, comment: item.comment || "", name: item.name, phonenumber: item.phonenumber, _id: item._id, status:item.status});
    setshowmodal(true);
  };

  const handlenamechange = (val) => {
    const phone = contactmap.get(val);
    setformdata({...formdata, name: val, phonenumber: phone || formdata.phonenumber});
  };

  const handlesubmit = async () => {
    if (!isvaliddatetime(formdata.date + "T" + formdata.time)) {
      alert("Date not available: " + formdata.date + " " + formdata.time);
      return false;
    }
    if (!formdata.status) {
      formdata.status = "Payment Pending";
    }
   
    let patient = patientdata.find(item => item.phonenumber == formdata.phonenumber);
    let patientpayload = {data: {name:formdata.name, phonenumber:formdata.phonenumber, datatype:"patientdata"}};

    if (patient) {
      patientpayload.data._id = patient._id;
    }

    let patientid = await updatedata(patientpayload);
    formdata._patientid = patientid[0].id;
    
    let payload = {data:{...formdata, datatype:"appointmentdata", datetime:formdata.date+"T"+formdata.time}};
    
    if (formdata._id) {
        payload = {data:{...formdata, datatype:"appointmentdata",status:formdata.status}};
    } 


    const result = await updatedata(payload);

    if (payload.data._id) {
      await fetchdata();
      setshowmodal(false);
    }
    if (formdata.status == "Payment Pending") {
      window.location.href = "/dummypayment?appointmentid=" + (formdata._id || result[0].id);
    }
  };

  const isvaliddatetime = (currdatetime) => {
    let found = appointmentdata.find((a) =>  {
        return (!formdata._id || a._userid != APPUSER.user.userid) && a.datetime.indexOf(currdatetime) >= 0;
    });
    
    if (!found) {
      const currdatetimeobj = new Date(currdatetime);
      found = CLOSEDDATA.find((c) => {
        const startdate = new Date(c.startdate);
        const enddate = new Date(c.enddate);
        return currdatetimeobj.getTime() >= startdate.getTime() && currdatetimeobj.getTime() < enddate.getTime();
      });

    }
    return !found;
  }

  useEffect(() => { fetchdata(); }, []);

  const userappointmentdata = useMemo(() => {
    return appointmentdata.filter(item => item._userid == window.APPUSER?.user?.userid);
  }, [appointmentdata]); // Only runs when appointmentdata changes

  const contactmap = useMemo(() => {
    return new Map(userappointmentdata.map(i => [i.name, i.phonenumber]));
  }, [userappointmentdata]);

  return (
    <div className="content-area">
      <div className="table-header-row">
        <h1 className="dash-title">My Appointments</h1>
        <button className="btn-blue" onClick={() => {
            let date = new Date();
            date.setDate(date.getDate()+1);
            date = formatdate(date);

            setformdata({date:getdate(date).datestr, datestr:date, time:"", comment:"", name:userappointmentdata[0]?.name, phonenumber:userappointmentdata[0]?.phonenumber, _id: null}); 
            setshowmodal(true);
            }}>
          + Book Appointment
        </button>
      </div>
      <DashboardTable userappointmentdata={userappointmentdata} openedit={openedit} />
      <AppointmentForm 
        showmodal={showmodal} setshowmodal={setshowmodal} 
        formdata={formdata} setformdata={setformdata}
        handlesubmit={handlesubmit}
        contactmap={contactmap} 
        handlenamechange={handlenamechange}
        appointmentdata={appointmentdata}
        isvaliddatetime={isvaliddatetime}
      />
    </div>
  );
};

export default Appointment;